import { useQuery } from '@tanstack/react-query';

import { energyApi } from '../api';
import { SatisfactionByDate } from '@demind-inc/core';

interface UseSatisfactionEmaParams {
  userId: string;
  startDate: string;
  endDate: string;
}

interface UseSatisfactionEmaQueryParams {
  queryKey: ['lifestack.satisfactionEma', { userId: string; startDate: string; endDate: string }];
}

export const useSatisfactionEmas = ({ userId, startDate, endDate }: UseSatisfactionEmaParams) => {
  const satisfactionEmaQuery = useQuery({
    queryKey: ['lifestack.satisfactionEma', { userId, startDate, endDate }],
    queryFn: ({ queryKey }: UseSatisfactionEmaQueryParams) => {
      const [, { userId, startDate, endDate }] = queryKey;
      return energyApi
        .getSatisfactionEma(userId, startDate, endDate)
        .then(({ data }) => data as SatisfactionByDate[]);
    },
    refetchOnWindowFocus: false,
    enabled: !!userId && !!startDate && !!endDate,
    staleTime: 15000, // 15s
  });

  return {
    satisfactionEmas: satisfactionEmaQuery.data ?? [],
    ...satisfactionEmaQuery,
  };
};
